import Illustration from '../../../components/ui/Illustration';
import illuTeleverser from '../../../assets/illustrations/fonctionnalites/televerser.svg?raw';

// Mode « Compilation multi-docs » : nom, nb questions, dropzone multi-fichiers.
// L'état reste chez le parent (dragging partagé avec l'overlay de page).
export default function MultiDocPicker({
    enrichmentTarget, label, setLabel, submitting,
    aiNbQuestions, setAiNbQuestions,
    dragging, setDragging, fileRef, onAddFiles, maxDocs,
}) {
    return (
        <>
            {!enrichmentTarget && (
                <input type="text" placeholder="Nom du sujet (ex. Synthèse droit administratif)" value={label} onChange={(e) => setLabel(e.target.value)} maxLength={100} disabled={submitting} />
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginTop: 8 }}>
                <label style={{ fontSize: '0.85em', color: 'var(--text-muted)' }}>Nombre approximatif de questions :</label>
                <select value={aiNbQuestions} onChange={e => setAiNbQuestions(Number(e.target.value))} disabled={submitting}
                    className="mt-upload-category-select" style={{ width: 'auto' }}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                </select>
            </div>

            <div
                className={`mt-upload-dropzone ${dragging ? 'mt-upload-dropzone--dragging' : ''}`}
                style={{ marginTop: 10 }}
                onClick={() => fileRef.current?.click()}
                onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
                onDragLeave={() => setDragging(false)}
                onDrop={(e) => {
                    e.preventDefault(); setDragging(false);
                    onAddFiles(e.dataTransfer.files);
                }}
            >
                <Illustration svg={illuTeleverser} color="#6d28d9" className="mt-upload-illu mt-upload-illu--small" />
                <span>Cliquer ou glisser-déposer (PDF, DOCX, TXT — max {maxDocs} docs, 10 Mo chacun)</span>
                <input
                    ref={fileRef}
                    type="file"
                    accept=".pdf,.docx,.doc,.txt,.csv,.html,.md"
                    multiple
                    hidden
                    onChange={(e) => { onAddFiles(e.target.files); e.target.value = ''; }}
                />
            </div>
        </>
    );
}
